import Axios from 'axios';
import config from '../config';
import { saveAuthSession } from './authSession';

export const refreshToken = () => {
  const token = localStorage.getItem('accessToken');
  if (!token) return;

  return Axios.post(config.apiBaseUrl + 'refresh-token', undefined, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      // Ignore a response for a session that was cleared or replaced while waiting.
      if (localStorage.getItem('accessToken') !== token) return null;
      return saveAuthSession(response.data);
    })
    .catch((error) => {
      // The shared 401 handler clears revoked sessions. Keep the token on
      // network errors, forbidden responses and server failures.
      if (localStorage.getItem('accessToken') === token && !error.sessionExpiryHandled) {
        const data = error.response && error.response.data;
        window.alert(typeof data === 'string' && data ? data : 'Unable to refresh your session. Please try again later.');
      }
      return null;
    });
};
